import type { IFormBuilder } from '../FormBuilder';
import { getNestedFormBuilder } from './nestedFormBuilderRegistry';

/**
 * FormBuilder для форм, которые открываются из самой формы, пикеров и гридов
 * (подформы, формы строк таблиц, модалки справочников, детали документа).
 * Прямой импорт FormBuilder замыкал бы его контролы на самих себя; FormBuilder
 * регистрирует себя в nestedFormBuilderRegistry при загрузке своего модуля.
 */
const NestedFormBuilder = <TFieldValues extends object = object>(props: IFormBuilder<TFieldValues>) => {
    const FormBuilder = getNestedFormBuilder();

    return <FormBuilder {...props} />;
};

export default NestedFormBuilder;
